import {
    GET_LOGGED_EMPLOYEE,
    CHANGE_PROFILE_MODAL_STATE,
} from './loggedEmployeeConstants';
import { setValue } from '../../lib/immutable_wrapper'

const initialState = {
    loggedEmployee: null,
    profileModalOpened: false,
}

export function loggedEmployee(state = initialState, action) {
    switch (action.type) {
        case GET_LOGGED_EMPLOYEE:
            return setValue(state, ['loggedEmployee'], action.loggedEmployee);
        case CHANGE_PROFILE_MODAL_STATE:
            return setValue(state, ['profileModalOpened'], action.profileModalOpened);
        default:
            return state;
    }
}
